module.exports = __webpack_public_path__ + "img/WhatsApp Image 2021-12-19 at 5.01.59 PM.bdfca337.png";